import React from 'react'
import {connect} from 'react-redux'

import '../../asset/less/component.css'

import {Input, Table} from 'antd'
import {getNotifications} from '../../api/notifications'
import GalleryTablePanel from "../../component/GalleryTablePanel";
import {URL_NEW_NOTIFICATION_ADMIN} from "../../const";
import {SortAscendingOutlined, SortDescendingOutlined} from "@ant-design/icons";
import {is_admin_user} from "../../app/role";

const {TextArea} = Input
const {Column} = Table

@connect((state) => ({
    //decorator, gives component access to the state
    userId: state.user.info.id,
    email: state.user.info.email,
    role: state.user.info.role
}))
class Notification extends React.Component {
    constructor(props) {
        super(props)
        this.columns = [
            {
                title: '#',
                dataIndex: 'id',
                key: 'id',
                width: 64
            },
            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
                width: 146
            },
            {
                title: 'Title',
                dataIndex: 'title',
                key: 'title',
                width: 125,
                render: (text, record) => <h4>{text}</h4>
            },
            {
                title: 'Short Msg',
                dataIndex: 'message',
                key: 'message',
                width: 256,
                render: (text, record) => <p>{text}</p>
            },
            {
                title: 'Body',
                dataIndex: 'body',
                key: 'body',
                render: (text, record) => <div style={{maxHeight: 320, overflowY: 'auto'}}>
                    <div dangerouslySetInnerHTML={{__html: text}}></div>
                </div>
            },
        ]
        this.allColumns = []
        this.sortOptions = [
            {
                text: 'Create New (new)',
                value: '-created_at',
                icon: <SortDescendingOutlined/>
            },
            {
                text: 'Create At (old)',
                value: 'created_at',
                icon: <SortAscendingOutlined/>
            },
        ]
    }

    requestTheData = (pageId, pageSize, order, filters, search, cancelToken) => {
        const requestFunc = is_admin_user(this.props) ? getNotifications : getNotifications
        return requestFunc(
            pageId,
            pageSize,
            {
                search: search,
                ordering: order,
            },
            filters,
            cancelToken
        )
    }

    render() {
        return (
            <div>
                <GalleryTablePanel artistId={this.props.artistId}
                                   role={this.props.role}
                                   viewOptions={['table']}
                                   name={'notification'} requestData={this.requestTheData}
                                   columns={this.columns}
                                   sortOptions={this.sortOptions} defaultSortOption={this.sortOptions[0]}
                                   allColumns={this.allColumns} tableWidth={1200}
                                   addNewUrl={URL_NEW_NOTIFICATION_ADMIN}
                                   getEditUrl={this.getEditUrl}
                                   deleteData={this.deleteData}
                                   bulkUpdateData={this.bulkUpdateData}
                                   importOptions={[]}
                                   exportOptions={['excel']}
                                   {...this.props} />
            </div>
        )
    }
}

export default Notification
